export default "__VITE_ASSET__BfhBSFOU__"